<template>
    <div>
        <div v-if='init_type == "staff"' class='m-2 d-flex flex-row align-items-center justify-content-between'>
            <div class="search-filter">
                <label class='mr-2 sr-only' for='filter'>{{ capitalise($t("translations.filter")) }}</label>
                <input class='mr-3 form-control' id='filter' type='text' v-model='filter' :placeholder="capitalise($t('translations.filter'))"><span></span>
            </div>
            <div class='d-flex flex-row align-items-center'>
                <b-form-checkbox v-model="show_all" name="check-button" switch>
                <!-- {{ capitalise($t("translations.show_all_clinicians")) }} -->
                {{ $t("translations.show_available_all_option") }}
                </b-form-checkbox>
                <!-- <input class='ml-auto mr-2' id='show_all_clinicians' type='checkbox' v-model='show_all_assignable'>
                <label for='show_all_clinicians'>{{ capitalise($t("translations.show_all_clinicians")) }}</label> -->
            </div>
        </div> 
        <template v-for="(item) in custom_actions">
            <template v-if='shown(item)'>
                <button :key='item.id' v-on:click='actionClick(item)' tag="button" class="card-button w-100 mb-2">
                    <div class="card-icon"><i v-if='item.icon' :class='"fa fa-" + item.icon'></i></div>
                    <div><h2>{{ item.title }}</h2></div>
                </button>
            </template>
        </template>

        <!-- Patient version -->
        <!-- <button v-on:click='goNext("request")' class="card-button w-100 mb-2" title="Consult your GP">
            <div class="card-icon"><img src="/img/egl/icon-placeholder.svg"></div>
            <div><h2>{{ $t('translations.consult_your_GP')}}</h2></div>
        </button> -->
        <!-- <button v-else v-on:click='goNext("request")' class="btn btn-round btn-block btn-primary">{{ $t('translations.consult_your_GP')}}</button> -->

        <!-- Proxy version-->
        <!-- <router-link :to="{name: 'threadCreate', params: {user_id: $route.params.user_id}}" tag="button" class="card-button w-100 mb-2">
            <div class="card-icon"><img src="/img/egl/icon-placeholder.svg" alt="link icon"></div>
            <div><h2>{{ $t('translations.consult_your_GP')}}</h2></div>
        </router-link> -->
    </div>
</template>

<script>
	export default {
		props: {
            custom_actions: {
                default: () => {
                    return {
                        
                    }
                }
            },
            init_type: {

            },
            user_id: {
                
            },
            user: {
                default: null
            },
		},
		data: function(){
			return {
                show_all: true,
                filter: "",
                signpost_filter: [],
                keywords: null,
                keyword_title: "Keywords",
			};
		},
        computed: {
            
        },
        watch: {
            show_all(value) {
                if(this.is_staff()) {
                    this.setSetting("CustomActionSelect_show_all", value);
                }
            },
        },
        mounted() {
            if(this.is_staff()) {
                this.show_all = this.getSetting("CustomActionSelect_show_all", true);
            }
        },

        methods: {
            shown(item) {
                if(this.keywords) {
                    if(!this.signpost_filter.find(filter => {return item.id == filter.id})) {
                        return false;
                    }
                } 
                else if (!item.user_selectable) {
                    return false;
                }
                
                switch(this.init_type) {
                    case "staff":
                        // Only show forms to staff (not links)
                        if(item.form_id) {  
                            // If we have a filter, show all matches
                            if(this.filter) {
                                return !this.filter || item.title.toLowerCase().includes(this.filter.toLowerCase());
                            }
                            // If we are showing all ...
                            else if(this.show_all) {
                                return true;
                            }
                            // Finally, show it if the item is actually available
                            // And the system is avaiable (this matches what patients 
                            // see minus url links)
                            else if(this.$root.provider.calc_service_status !== this.$root.lookup.service_status.OFFLINE) {
                                return item.available && this.availableForUser(item);
                            }
                        }
                        return false;
                    default:
                        return item.available && this.availableForUser(item);
                }
            },
            setSignpostFilter(keywords) {
                this.keywords = keywords;
                this.signpost_filter = [];

                var data = {
                    type: "form",
                    data: this.keywords,
                    //id: visible_items.map(a => a.foo),
                };

                return axios.post(`${this.$root.apiBase}/signpost`, data).then((res) => {
                    this.signpost_filter = res.data;
                    Promise.resolve();
                });
            },
            // This is a helper for parent embeds where we are using the component
            // to check for availability without actually rendering.
            getVisibleItems(data) {
                var visible_items = [];
                for(var item of this.custom_actions) {
                    if(this.shown(item)) {
                        visible_items.push(item);
                    }
                }

                return visible_items;
            },
            availableForUser(item) {
                var test_user;
                var available = true;

                if(Array.isArray(item.component_filter)) {
                    // Mainly for provider requests where we have a single user already.
                    if(this.user) {
                        test_user = this.user;
                    }
                    else if(this.user_id == this.$root.user.id) {
                        test_user = this.$root.user;
                    }
                    else {
                        test_user = this.getCaree(this.user_id);
                    }
                    console.info(item.title);
                    console.info(test_user.dob);
                    
                    if(test_user) {
                        for(var filter of item.component_filter) {
                            console.info(filter.filter);
                            switch(filter.filter) {
                                case "Age":
                                    if(test_user.dob) {
                                        var user_age = this.moment().diff(test_user.dob, 'years', false);
                                        console.info(user_age);

                                        switch(filter.operand) {
                                            case "=":
                                                if(user_age != filter.value) {
                                                    available = false;
                                                }
                                            break;
                                            case "<=":
                                                if(!(user_age <= filter.value)) {
                                                    available = false;
                                                }
                                            break;
                                            case ">=":
                                                if(!(user_age >= filter.value)) {
                                                    available = false;
                                                }
                                            break;
                                        }
                                    }
                                    else {
                                        available = false;
                                    }
                                break;
                                case "Tag":
                                    console.log(Array.isArray(filter.value), filter.value.length)
                                    if(Array.isArray(filter.value) && filter.value.length) {
                                        console.log(Array.isArray(test_user.user_tag));
                                        if(Array.isArray(test_user.user_tag)) {
                                            var got_tag = false;
                                            for(var tag of filter.value) {
                                                console.log(tag);
                                                console.log(test_user.user_tag);
                                                if(test_user.user_tag.find(obj => {return tag.tag_id == obj.tag_id})) {
                                                    got_tag = true;
                                                }
                                            }
                                            if(!got_tag) {
                                                available = false;    
                                            }
                                        }
                                        else {
                                            available = false;
                                        }
                                    }
                                break;
                                case "NHS Login":
                                    if(filter.value && !test_user.nhs_login) {
                                        available = false;
                                    }
                                    if(!filter.value && test_user.nhs_login) {
                                        available = false;
                                    }
                                break;
                                case "EGL/PHR App Linked":
                                    if(filter.value && !test_user.egl_profile_id) {
                                        available = false;
                                    }
                                    if(!filter.value && test_user.egl_profile_id) {
                                        available = false;
                                    }
                                break;
                                case "Preferred Site":
                                    var provider = test_user.user_provider.find(provider => {return provider.id == this.$root.provider.id});
                                    if(!provider || provider.site_id != filter.value) {
                                        available = false;
                                    }
                                break;
                                case "Gender":
                                    if(test_user.gender != filter.value) {
                                        available = false;
                                    }
                                break;
                                case "Verification Status":
                                    if(test_user.verification_status_id != filter.value) {
                                        available = false;
                                    }
                                break;
                                
                            }
                            console.info("Available: ", available);
                        }
                    }
                }
                console.info("Available: ", available);
                return available;
            },
            actionClick(item) {
                if(item.url) {
                    this.followLink(item);
                }
                else {
                    this.initForm(item.id);
                }
            },
            followLink(item) {
                this.setLoading(true);
                axios.post(this.$root.apiBase + "/custom_actions/followLink", item).then((res) => {
                    this.setLoading(false);
                    window.location = item.url;
                })
                .catch(error => {
                    this.setLoading(false);
                    this.handleError(error, "run action");
                });            
            },
            initForm(action_id) {
                var data = {
                    action_id: action_id,
                    user_id: this.user_id
                }
                axios.post(this.$root.apiBase + "/formsubmissions/existing_or_new_from_custom_action", data).then((res) => {
                    if(this.init_type == "staff") {
                        this.$emit("input", res.data.id);
                    }
                    else {
                        app.$root.$router.push({path: "/form-submission/" + res.data.id});
                    }
                    
                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "create");
                });
            },
        }
    }
</script>
